/* eslint-disable react/require-default-props */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/alt-text */
import { prefix } from 'constants/optionCommon';
import { renderUnderline } from 'modules/Presentation/Viewer/components/ExercicesTypes_MENARD/OneChoice';
import { Col, Row } from 'antd';
import { isImageUrl } from 'utils/validateValue';
import { HeaderCommon, QuestionNumber, QuestionText } from '../RenderCommon';
import { QuestionComponentProps } from '../../type';

// const MultipleChoice = ({ questionData, questionIndex, isCombineChild }: QuestionComponentProps) => {
// const optionType = questionData.optionType.toUpperCase();
const MultipleChoice = ({ questionData, questionIndex, isCombineChild, printMode }: QuestionComponentProps & { printMode?: boolean }) => {
  const { answers, questionText } = questionData;
  const renderAnswers = () => {
    return (
      <Row gutter={[12, 12]}>
        {Array.isArray(answers) &&
          answers?.map((question: any, childIndex: number) => {
            return (
              <Col key={childIndex} span={24}>
                <div className='tw-mb-3' dangerouslySetInnerHTML={{ __html: question.question }} />
                <Row gutter={12} style={printMode ? { flexWrap: 'wrap' } : {}}>
                  {/* {question.answers.map((answer: any, index: number) => { */}

                  {question.answers.map((answer: { answer: string }, index: number) => {
                    // Nếu đang ở chế độ in (printMode === true) thì luôn hiển thị hình ảnh
                    if (printMode) {
                      return (
                        <Col key={index} flex={question.answerLayout === 'horizontal' ? `${100 / question.answers.length}%` : '100%'} style={printMode ? { marginBottom: 10 } : {}}>
                          {`${prefix[index]}. `}
                          {isImageUrl(answer.answer) ? <img src={answer.answer} style={{ maxHeight: 100, marginRight: 5 }} alt={`answer-${index}`} /> : renderUnderline(answer.answer)}
                        </Col>
                      );
                    }
                    // Nếu không in, hiển thị theo bình thường dựa trên answerType

                    return (
                      <Col key={index} flex={question.answerLayout === 'horizontal' ? `${100 / question.answers.length}%` : '100%'}>
                        {question.answerType === 'image' ? (
                          <div>
                            {`${prefix[index]}. `}
                            <img src={answer.answer} style={{ display: 'inline-block', maxHeight: 100 }} />
                          </div>
                        ) : (
                          <div>
                            {`${prefix[index]}. `}
                            {renderUnderline(answer.answer)}
                          </div>
                        )}
                      </Col>
                    );
                  })}
                </Row>
              </Col>
            );
          })}
      </Row>
    );
  };

  return (
    <div style={{ marginLeft: isCombineChild ? 15 : 0 }}>
      <HeaderCommon key={`multiple-choice-${questionData.id}`} questionIndex={questionIndex} questionData={questionData} isCombineChild={isCombineChild} />
      {questionData.imageUrl && (
        <div className='tw-mb-4' style={{ display: 'flex', justifyContent: 'center' }}>
          <img src={questionData.imageUrl} style={{ maxHeight: 200 }} />
        </div>
      )}
      {(isCombineChild || questionText) && (
        <div className='tw-mb-4'>
          <QuestionNumber isCombineChild={isCombineChild} questionIndex={questionIndex} />
          <QuestionText key={questionIndex} questionText={questionText} />
        </div>
      )}
      <div>{renderAnswers()}</div>
    </div>
  );
};

export default MultipleChoice;
